import React from "react";

export const LineStartLabels = ({ lines }) => {
    if (!lines || !lines.length) return null;

    return (
        <>
            {lines.map((line, index) => {
                const points = line.props?.points;
                if (!points || !points.length) return null;

                const firstPoint = points[0];
                if (!firstPoint) return null;

                const name = line.item?.props?.dataKey;
                const color = line.item?.props?.stroke;

                if (!name) return null;

                return (
                    <text
                        key={`label-${name}-${index}`}
                        x={firstPoint.x - 18}
                        y={firstPoint.y}
                        textAnchor="end"
                        dominantBaseline="middle"
                        fill={color}
                        fontSize={14}
                        fontWeight={500}
                        style={{ pointerEvents: "none" }}
                    >
                        {name}: {firstPoint.value}
                    </text>
                );
            })}
        </>
    );
};

